import { httpClient } from '../network/httpclient/HttpClientFactory';
//import { wrapHttpClient } from '../helper/HttpHelper';
import authHeader from './Header';

/* 메인 리스트 */
const mainList = param =>
    httpClient.post('/facemapping-main-info', param, { headers: authHeader() }).then(res => res.data);

/* 리스트 */
const list = param => httpClient.post('/facemapping-image', param, { headers: authHeader() }).then(res => res.data);

/* 상세 */
const detail = id => httpClient.get(`/facemapping/${id}`, { headers: authHeader() }).then(res => res.data);

/* 복사 */
const copy = id => httpClient.post(`/copy/${id}`, {}, { headers: authHeader() }).then(res => res.data);

/* step1 저장 */
const saveSiteInfo = param =>
    httpClient.post('/facemapping/siteInfo', param, { headers: authHeader() }).then(res => res.data);

/* step2 저장 */
const postImge = param => httpClient.post('/facemapping/image', param, { headers: authHeader() }).then(res => res.data);

/* step3 저장 */
const postImgeEtc = param =>
    httpClient.post('/facemapping/image-etc', param, { headers: authHeader() }).then(res => res.data);

/* step4 저장 */
const postStrength = param =>
    httpClient.post('/facemapping/strength', param, { headers: authHeader() }).then(res => res.data);

/*tbm step2 저장 */
const postImgTbm = param =>
    httpClient.post('/facemapping/image-tbm', param, { headers: authHeader() }).then(res => res.data);

/* 승인 */
const approve = (id, state) =>
    httpClient.put(`/approve/${id}/${state}`, { headers: authHeader() }).then(res => res.data);

/* 삭제 */
const deleteData = id => httpClient.delete(`/facemapping/${id}`, { headers: authHeader() }).then(res => res.data);

/* 3D모델보(정보 및 스테이션 개수) */
const getThreeDimensionalModel = param =>
    httpClient.post(`/three-dimensional-model`, param, { headers: authHeader() }).then(res => res.data);

/* 3D 데이타 목록  */
const getThreeDimensionalList = param =>
    httpClient.post(`/three-dimensional-data`, param, { headers: authHeader() }).then(res => res.data);

const putThreeDimensional = param =>
    httpClient.put(`/facemapping/three-dimensional`, param, { headers: authHeader() }).then(res => res.data);

const sendSms = id => httpClient.put(`/sendSms/${id}`, {}, { headers: authHeader() }).then(res => res.data);

const postComment = param =>
    httpClient.post(`/facemapping/comment`, param, { headers: authHeader() }).then(res => res.data);

const getCommentList = id =>
    httpClient.get(`/facemapping/comment/${id}`, { headers: authHeader() }).then(res => res.data);

const deleteComment = id =>
    httpClient.delete(`/facemapping/comment/${id}`, { headers: authHeader() }).then(res => res.data);

export default {
    mainList,
    list,
    detail,
    copy,
    saveSiteInfo,
    postImge,
    postImgeEtc,
    postStrength,
    postImgTbm,
    approve,
    deleteData,
    getThreeDimensionalModel,
    getThreeDimensionalList,
    sendSms,
    putThreeDimensional,
    postComment,
    getCommentList,
    deleteComment
};
